<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="comments"/> ZNS
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="tabIndex">
          <b-tab :disabled="!['owner','admin', 'tech' , 'operationsManager', 'account', 'am'].includes($store.state.user.role)">
            <template #title>
              {{ $t('znsTemplate') }}
            </template>
          </b-tab>
          <b-tab>
            <template #title>
              {{ $t('znsHistory') }}
            </template>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <z-n-s-template-list v-if="tabIndex === 0"></z-n-s-template-list>
    <history v-if="tabIndex === 1"></history>
  </main>
</template>

<script>


import ZNSTemplateList from "@/views/zns/ZNSTemplateList.vue";
import History from "@/views/zns/History.vue";

export default {
  components: {History, ZNSTemplateList},
  data() {
    return {
      tabIndex: 0,
    }
  },
  i18n: {
    messages: {
      en: {
        znsHistory: 'ZNS history',
        znsTemplate: 'ZNS template',
      },
      vi: {
        znsHistory: 'Lịch sử ZNS',
        znsTemplate: 'Mẫu tin nhắn ZNS',
      }
    }
  },
}
</script>